
import React from 'react';
// functions


function SubTitlePart({ text }) {

  return (
      <RenderSubTitleText text={ text } />
  );
}


function RenderSubTitleText({ text }) {
  return (
    <div><strong>{ text }</strong></div>
  );
}

export default SubTitlePart;



// WEBPACK FOOTER //
// ./src/cards/templates/DetailsConfirmCard/subTitlePart.js